import React, { useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import  code from '../../assets/images/code.png';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';
import ContentController from '../../apis/controller/content.controller';
import { NavItem } from 'react-bootstrap';



function Hiring() {
    const [hireResources, setHireResources] = useState();
    const [breadCrumbs, setBreadcrumbs] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getPartners();
        window.scrollTo(0, 0);
    }, []);

    const getPartners = async () => {
        setLoader(true);
        let res = await new ContentController().hire();
        if (res && res.status) {
            setHireResources(res.page);
            setBreadcrumbs(res.breadcrumb);
        }
        setLoader(false);
    };

	return (
		<>
	         {breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
			    {hireResources && <section className="second-level-section">
                    <div className="container">
                        <div className="row">
                            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className="left-box tick-icon-list">
                                    <h1>{hireResources.title}</h1>
                                    <h2>{hireResources.sub_title}</h2>
                                        <p>{hireResources.description}</p>
                                    <div className="bannertext">
                                        <p>{hireResources.text}</p>
                                    </div>
                                    <div className="terms">
                                        <ul>
                                        {hireResources.terms.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                            {/* <li>On-time delivery</li>
                                            <li>No legal employment liability, no recruitment expenses</li>
                                            <li>Complete control over the team</li>
                                            <li>Transparency</li> */}
                                        </ul>
                                    </div>
                                    <div className="count-box-outer">
                                    {hireResources.count_box.map((item, index) => (
                                        <div key={index} className="count-box flex-4">
                                            <span className="count-box-big clr-yellow">{item.count}+</span>
                                            <span className="count-box-small">{item.title}</span>
                                        </div>
                                    ))}
                                        
                                    </div>
                                </div>
                            </div>
                            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='intersted'>
                                    <div className='inner_area'>
                                        <div className='code_img'>
                                            <div className='img_area'>
                                                <img src={code}  />
                                            </div>
                                            <div className='text_line'>
                                                Interested? Hire best Software developers now!
                                            </div>
                                            <div className='reach'>
                                                <Link to={routes.contact} className="btn-primary_set">Contact Us </Link>
                                            </div>   
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </section>}
		</>
	);
}

export default Hiring;
